import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from '~/Product/Action';
import { showAllProductsAction } from '~/Product/actions';
import { State, ThunkDispatch } from '~/Store';
import { TailwindTooltip } from '../../atoms/TailwindTooltip';
import { Checkbox } from '../../atoms/Checkbox';
import Icon from '~/UI/Icon';

import { CzechHideExcludedProductsTooltip, czechHideExcludedProductsLabel } from './czechHideExcludedProducts';

export interface Props {
	alternativeProductsCount: number;
}

export function ProductGroupShowAllItemsSwitch({ alternativeProductsCount }: Props) {
	const showAllProducts = useSelector<State, boolean>((state) => state.products.showAllProducts);
	const dispatch: ThunkDispatch<Action> = useDispatch();
	const update = useCallback((showAllProducts: boolean) => {
		dispatch(showAllProductsAction(!showAllProducts));
	}, []);

	if (alternativeProductsCount === 0) {
		return null;
	}

	return (
		<label
			htmlFor='showAllProducts'
			className='inline-flex max-w-lg items-center gap-x-2 justify-end text-[12px] leading-[15px] cursor-pointer'
		>
			<Checkbox id='showAllProducts' name='showAllProducts' checked={!showAllProducts} onChange={update} />
			{czechHideExcludedProductsLabel(alternativeProductsCount, 'do výpočtu maximální ceny')}
			<TailwindTooltip
				reference={<Icon name='violet-question-mark' />}
				displayClass='relative h-4 inline-block'
				position='left'
				portal
			>
				<CzechHideExcludedProductsTooltip />
			</TailwindTooltip>
		</label>
	);
}
